"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CloseText = exports.CloseContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _Close = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close24"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _mixins = require("../../styles/mixins");
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var HBModalCloseButton = function HBModalCloseButton(_ref) {
  var onClose = _ref.onClose,
    closeButtonText = _ref.closeButtonText,
    closeButtonTooltipText = _ref.closeButtonTooltipText,
    _ref$closeIconColor = _ref.closeIconColor,
    closeIconColor = _ref$closeIconColor === void 0 ? _colors["default"].neutral900 : _ref$closeIconColor;
  return /*#__PURE__*/_react["default"].createElement(CloseContainer, {
    onClick: onClose,
    "aria-label": "close dialog",
    testId: "hb-modal-close--button"
  }, closeButtonText && /*#__PURE__*/_react["default"].createElement(CloseText, {
    type: "subtitle16",
    color: "textTertiary"
  }, closeButtonText), closeButtonTooltipText ? /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], {
    placement: "top",
    target: /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      color: closeIconColor
    })
  }, closeButtonTooltipText) : /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    color: closeIconColor
  }));
};
var _default = exports["default"] = HBModalCloseButton; // -------------------------------- Styles -------------------------------- //
var CloseContainer = exports.CloseContainer = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBModalCloseButton__CloseContainer",
  componentId: "sc-1a4xcoz-0"
})(["position:absolute;right:16px;top:18px;height:24px;cursor:pointer;display:flex;align-items:center;z-index:1;", " i{line-height:0;}"], _mixins.hideInPrint);
var CloseText = exports.CloseText = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBModalCloseButton__CloseText",
  componentId: "sc-1a4xcoz-1"
})(["margin-right:10px;margin-top:1px;"]);
//# sourceMappingURL=HBModalCloseButton.js.map